import axios from 'axios';
import { remotehost } from '../../host';
import store from '../../store/store';
import { logout } from '../../users/loggedUser/actions';
import { loadState } from '../../containers/localStorage';
export const init = () => {
  axios.defaults.baseURL = remotehost + '/api/v1';
  const user = loadState('account') || {};
  if (user.userId && !user.token) {
    store.dispatch(logout());
  }
  if (user.token)
    axios.defaults.headers.common['authorization'] = `Bearer ${user.token}`;
  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (error.response.status === 401) {
        store.dispatch(logout());
      } else {
        throw error;
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/utils/helpers/axios.js